import Loadable from 'react-loadable';
import { Loader } from '../../components';

const AsyncNotifications = Loadable({
  loader: () => import('./Notifications'),
  loading: Loader,
});

export default AsyncNotifications;
